module.exports = __webpack_public_path__ + "img/bus-service-icon1.ea05249f.png";